import React, { useEffect, useState } from 'react';
import api from '../api/axios';

const priCfg = { high:{label:'Yuksek',color:'bg-red-100 text-red-700',dot:'bg-red-500'}, medium:{label:'Orta',color:'bg-amber-100 text-amber-700',dot:'bg-amber-500'}, low:{label:'Dusuk',color:'bg-gray-100 text-gray-600',dot:'bg-gray-400'} };
const stsCfg = { pending:{label:'Bekliyor'}, in_progress:{label:'Devam'}, done:{label:'Tamamlandi'}, cancelled:{label:'Iptal'} };
const ef = {title:'',description:'',assigned_to:'',priority:'medium',due_date:''};

export default function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState('all');
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(ef);
  const [loading, setLoading] = useState(false);

  const load = () => api.get('/tasks').then(r=>setTasks(r.data));
  useEffect(() => { load(); api.get('/users').then(r=>setUsers(r.data)).catch(()=>{}); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post('/tasks', {...form, due_date:form.due_date||null}); setShowForm(false); setForm(ef); load(); }
    catch(err) { const d=err.response?.data?.detail; alert('Hata: '+(Array.isArray(d)?d.map(x=>x.msg).join(', '):d||'Hata')); }
    finally { setLoading(false); }
  };

  const updateStatus = async (id, status) => { await api.put('/tasks/'+id, {status}); load(); };

  const counts = { all:tasks.length, pending:tasks.filter(t=>t.status==='pending').length, in_progress:tasks.filter(t=>t.status==='in_progress').length, done:tasks.filter(t=>t.status==='done').length };
  const filtered = filter === 'all' ? tasks : tasks.filter(t=>t.status===filter);

  return (
    <div className="space-y-5 animate-fadein">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Gorevler</h1>
          <p className="text-gray-500 text-sm mt-0.5">{counts.pending} bekleyen, {counts.in_progress} devam ediyor</p>
        </div>
        <button onClick={() => setShowForm(true)} className="btn-primary">+ Yeni Gorev</button>
      </div>

      <div className="flex gap-1 bg-gray-100 p-1 rounded-xl w-fit">
        {[['all','Tumu'],['pending','Bekleyen'],['in_progress','Devam'],['done','Tamamlanan']].map(([k,l]) => (
          <button key={k} onClick={() => setFilter(k)} className={"px-3 py-1.5 rounded-lg text-sm font-medium transition-all " + (filter===k ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500 hover:text-gray-700')}>
            {l} <span className="text-xs text-gray-400 ml-1">({counts[k]||0})</span>
          </button>
        ))}
      </div>

      {showForm && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setShowForm(false)}>
          <div className="modal animate-slideup">
            <div className="flex items-center justify-between mb-5">
              <h2 className="text-lg font-bold">Yeni Gorev</h2>
              <button onClick={() => setShowForm(false)} className="text-gray-400 hover:text-gray-600">✕</button>
            </div>
            <form onSubmit={handleSubmit} className="space-y-3">
              <input required value={form.title} onChange={e=>setForm({...form,title:e.target.value})} className="input" placeholder="Gorev Basligi *" />
              <textarea value={form.description} onChange={e=>setForm({...form,description:e.target.value})} rows={3} className="input resize-none" placeholder="Aciklama" />
              <div className="grid grid-cols-2 gap-3">
                <select required value={form.assigned_to} onChange={e=>setForm({...form,assigned_to:e.target.value})} className="input">
                  <option value="">Atanan kisi *</option>
                  {users.map(u=><option key={u.id} value={u.id}>{u.full_name}</option>)}
                </select>
                <select value={form.priority} onChange={e=>setForm({...form,priority:e.target.value})} className="input">
                  <option value="low">Dusuk</option><option value="medium">Orta</option><option value="high">Yuksek</option>
                </select>
              </div>
              <input type="datetime-local" value={form.due_date} onChange={e=>setForm({...form,due_date:e.target.value})} className="input" />
              <div className="flex gap-2 pt-2">
                <button type="submit" disabled={loading} className="btn-primary flex-1">{loading ? 'Kaydediliyor...' : 'Olustur'}</button>
                <button type="button" onClick={() => setShowForm(false)} className="btn-secondary flex-1">Iptal</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="space-y-2">
        {filtered.length === 0 ? (
          <div className="card p-10 text-center text-gray-400">Gorev bulunamadi</div>
        ) : filtered.map(task => (
          <div key={task.id} className={"card p-4 flex items-center gap-4 hover:shadow-md transition-all " + (task.status==='done' ? 'opacity-60' : '')}>
            <button onClick={() => updateStatus(task.id, task.status==='done' ? 'pending' : 'done')}
              className={"w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all " + (task.status==='done' ? 'bg-emerald-500 border-emerald-500' : 'border-gray-300 hover:border-emerald-400')}>
              {task.status==='done' && <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/></svg>}
            </button>
            <div className="flex-1 min-w-0">
              <p className={"font-semibold text-sm " + (task.status==='done' ? 'line-through text-gray-400' : 'text-gray-800')}>{task.title}</p>
              {task.description && <p className="text-xs text-gray-500 mt-0.5 truncate">{task.description}</p>}
              {task.due_date && <p className={"text-xs mt-1 " + (new Date(task.due_date) < new Date() && task.status!=='done' ? 'text-red-500' : 'text-gray-400')}>📅 {new Date(task.due_date).toLocaleDateString('tr-TR',{day:'numeric',month:'short'})}</p>}
            </div>
            <span className={"text-xs font-semibold px-2 py-1 rounded-full " + (priCfg[task.priority]?.color||'bg-gray-100 text-gray-500')}>{priCfg[task.priority]?.label}</span>
            <select value={task.status} onChange={e=>updateStatus(task.id,e.target.value)} className="border border-gray-200 rounded-lg text-xs px-2 py-1.5 bg-white focus:outline-none">
              {Object.entries(stsCfg).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
}
